/** @format */

import type { ImportJobStatus } from "@question-bank/shared";

/**
 *
 * Display label for each import job status.
 *
 */

export const importJobStatusLabels: Record<ImportJobStatus, string> = {
	pending: "Pending",
	running: "Running",
	complete: "Complete",
	failed: "Failed",
	rolling_back: "Rolling back",
	rolled_back: "Rolled back",
};
